import React, {Component} from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import Label from '../Label';
import Color from '../../styles/_variables.scss';
import {Search, GreenSearch, IconsError, CloseIconGray, IconsInfo} from '../../styles/icons';
import Config from '../../utils/Configuration';

class InputBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleClass: 'hideElement',
            autoCompleteToggle: false
        };
        // eslint-disable-next-line no-underscore-dangle
        this._isMounted = false;

        this.stateSetter = this.stateSetter.bind(this);
        this.keyUpHandler = this.keyUpHandler.bind(this);
        this.closeLabel = this.closeLabel.bind(this);
        this.inputFocusHandler = this.inputFocusHandler.bind(this);
        this.inputBlurHandler = this.inputBlurHandler.bind(this);
    }

    componentDidMount() {
        // eslint-disable-next-line no-underscore-dangle
        this._isMounted = true;
        if (this.props.inputValue) {
            this.stateSetter({toggleClass: ' '});
        }
    }

    componentDidUpdate() {
        if (this.props.inputValue && this.state.toggleClass.trim()) {
            this.stateSetter({toggleClass: ' '});
        }
    }

    componentWillUnmount() {
        // eslint-disable-next-line no-underscore-dangle
        this._isMounted = false;
    }

    stateSetter(state) {
        // eslint-disable-next-line no-underscore-dangle
        this._isMounted && this.setState({...state});
    }

    inputFocusHandler(event) {
        typeof this.props.onFocus === 'function' && this.props.onFocus(event);
        this.stateSetter({autoCompleteToggle: true});
    }

    inputBlurHandler(event) {
        typeof this.props.inputBlurHandler === 'function' && this.props.inputBlurHandler(event);
        setTimeout(() => {
            this.stateSetter({autoCompleteToggle: false});
        }, 250);
    }

    keyUpHandler(event) {
        const {value} = document.getElementById(event.target.id) || {};
        if (value) {
            this.stateSetter({toggleClass: ' '});
        } else {
            this.stateSetter({toggleClass: 'hideElement'});
        }
        if (this.props.inputPressedKeyUpHandler) {
            this.props.inputPressedKeyUpHandler(event);
        }
    }

    closeLabel(event) {
        this.setState({toggleClass: 'hideElement '});
        if (this.props.CloseLabel) {
            this.props.CloseLabel(event);
        }
    }

    render() {
        /* This is the Input Box. */
        const {
            inputRef,
            label,
            inputType = 'text',
            inputBoxType,
            isValid,
            inputName,
            inputValue,
            maxLength = 200,
            readOnly,
            inputPlaceholder,
            isDisabled,
            inputPressedKeyHandler,
            errorClass,
            errorMessage,
            inputChangeHandler,
            inputPressedKeyUpHandler,
            inputBoxSubTextClass,
            inputPasteHandler,
            onInputHandler,
            inputKeyDownHandler,
            reactInputBoxClassName = '',
            inputBoxSubText,
            inputClass = '',
            idValue,
            showCrossHair = true,
            inputBoxLabelClass = '',
            showCheckIcon = false,
            checkBoxClass = '',
            hideSpinner = true,
            inputAutoComplete = '',
            constantValueClass = '',
            inputBoxSubTextComponent,
            showSearchIcon = true,
            onClickIconsInfo,
            showMobileNumberInfo,
            autoComplete = {},
            invalidClassName = '',
            autoCompleteContainerClass = '',
            autoCompleteListClass = '',
            autoCompleteTextClass = '',
            isTextArea = false
        } = this.props;
        const isTelephoneInput = inputBoxType === 'Telephone-Input';
        const searchBoxClass =
            inputBoxType === 'Search-Input'
                ? 'searchInput'
                : inputBoxType === 'Green-Search-Input'
                ? 'searchInput'
                : '';
        const {
            autoCompleteList = [],
            autoCompleteLeadingIcon = null,
            onAutoCompleteClick = () => {},
            isLoading: showSkeletonAutoCompleteLoader = false
        } = autoComplete;
        const autoCompleteSkeletonLoaderList = Array(3).fill();
        const showAutoCompleteBlock =
            this.state.autoCompleteToggle &&
            [autoCompleteList.length > 0, showSkeletonAutoCompleteLoader, autoComplete.showEmptyBlock].includes(true);
        const constantValue =
            this.props.constantValue ||
            (isTelephoneInput && (
                <div className='px-2 pe-3 d-flex pt-1 mb-2px align-items-center fs-18 maxis-bold text-gunmetal'>
                    {Config.countryCode}
                    <div className='vert-line m-1 b-steel' />
                </div>
            ));
        const HtmlEl = isTextArea ? 'textarea' : 'input';
        const inputComponent = (
            <div className={`${constantValue ? 'has-const-dt' : ''} ${searchBoxClass}`}>
                {searchBoxClass && showSearchIcon ? (
                    inputBoxType === 'Green-Search-Input' ? (
                        <GreenSearch />
                    ) : (
                        <Search className='search-icon' />
                    )
                ) : (
                    ''
                )}
                {constantValue ? <div className={`const-dt ${constantValueClass}`}>{constantValue}</div> : ''}
                <HtmlEl
                    ref={inputRef}
                    type={inputType}
                    className={`${
                        isValid === false ? 'form-field-invalid' : 'form-field-valid'
                    } form-control inputBox ${inputClass} ${hideSpinner ? 'hides-number-spinner' : ''}`}
                    readOnly={readOnly}
                    name={inputName}
                    value={inputValue}
                    maxLength={isTelephoneInput? 10 : maxLength}
                    onPaste={inputPasteHandler}
                    placeholder={inputPlaceholder}
                    onChange={inputChangeHandler}
                    onFocus={this.inputFocusHandler}
                    onBlur={this.inputBlurHandler}
                    onKeyPress={inputPressedKeyHandler}
                    onInput={onInputHandler}
                    onKeyUp={searchBoxClass ? this.keyUpHandler : inputPressedKeyUpHandler}
                    onKeyDown={inputKeyDownHandler}
                    disabled={isDisabled}
                    id={idValue}
                    autoComplete={inputAutoComplete}
                    // eslint-disable-next-line react/no-unknown-property
                    enterKeyHint={inputType === 'search' ? 'search' : undefined}
                />
                {showCrossHair && searchBoxClass ? (
                    <div className={`closeIconContainer ${this.state.toggleClass}`}>
                        <div
                            className='closeIcon'
                            aria-label='Close'
                            onClick={this.closeLabel}
                            role='button'
                            tabIndex='-1'
                        >
                            <CloseIconGray className='mt-1 mt-lg-0' />
                        </div>
                    </div>
                ) : null}
                {showCheckIcon && checkBoxClass ? (
                    <i className={`material-icons ${checkBoxClass}`} tabIndex='-1'>
                        check_circle
                    </i>
                ) : null}
            </div>
        );
        return (
            <div className={`react-inputBox ${reactInputBoxClassName} `}>
                {label && !showMobileNumberInfo && <Label labelClass={`${inputBoxLabelClass}`} labelData={label} />}
                {label && showMobileNumberInfo && (
                    <div className='d-flex align-items-center'>
                        <Label labelClass={`${inputBoxLabelClass}`} labelData={label} />

                        <div onClick={() => onClickIconsInfo(true)}>
                            <IconsInfo className='cursor-pointer ml-1 mt--2px' />
                        </div>
                    </div>
                )}
                {inputComponent}

                {showAutoCompleteBlock && (
                    <div className='position-relative'>
                        <div
                            className={`autocomplete-container position-absolute bg-white ${autoCompleteContainerClass}`}
                        >
                            {autoComplete.showEmptyBlock && (
                                <div className='autocomplete-item empty-suggestion align-items-center d-flex flex-row px-2'>
                                    <div className='flex-shrink-0 leading-icon'>{autoCompleteLeadingIcon}</div>

                                    <span className={`autocomplete-text fs-12 ${autoCompleteTextClass}`}>
                                        {autoComplete.emptyAutoCompletePlaceholder}
                                    </span>
                                </div>
                            )}

                            {showSkeletonAutoCompleteLoader &&
                                autoCompleteSkeletonLoaderList.map((...[, index]) => (
                                    <div
                                        className='autocomplete-item align-items-center d-flex flex-row px-2'
                                        key={`auto_complete_loader_item_${index}`}
                                    >
                                        {autoCompleteLeadingIcon && (
                                            <Skeleton
                                                containerClassName='autocomplete-leading-icon-placeholder'
                                                baseColor={Color.offWhite}
                                            />
                                        )}
                                        <Skeleton
                                            containerClassName='autocomplete-placeholder'
                                            baseColor={Color.offWhite}
                                        />
                                    </div>
                                ))}

                            {autoCompleteList.map((autocomplete, index) => (
                                <div
                                    key={`auto_complete_item_${index}_${autocomplete.id || 'na'}`}
                                    className={`autocomplete-item maxis align-items-center px-2 cursor-pointer ${autoCompleteListClass} ${
                                        showSkeletonAutoCompleteLoader ? 'd-none' : 'd-flex'
                                    }`}
                                    onClick={() => {
                                        onAutoCompleteClick(autocomplete.value);
                                        this.stateSetter({autoCompleteToggle: false});
                                    }}
                                >
                                    <div className='flex-shrink-0 leading-icon'>{autoCompleteLeadingIcon}</div>

                                    <span className={`autocomplete-text fs-12 ${autoCompleteTextClass}`}>
                                        {autocomplete.highlightedText && (
                                            <strong className='pr-1 highlighted-text maxis-bold fs-14'>
                                                {autocomplete.highlightedText}
                                            </strong>
                                        )}
                                        <span dangerouslySetInnerHTML={{__html: autocomplete.text}} />
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {isValid === false && (
                    <div className={`d-flex ${invalidClassName}`}>
                        <div>
                            <IconsError className='mr-5px cursor-pointer' width={12} />
                        </div>
                        <span className={`${errorClass} error-message lh-normal pt-4px`}>{errorMessage}</span>
                    </div>
                )}
                {inputBoxSubText ? (
                    <div id='inputBoxSubText' className={`${inputBoxSubTextClass} form-text inputBoxSubText`}>
                        {inputBoxSubText}
                    </div>
                ) : (
                    ''
                )}
                {inputBoxSubTextComponent ? <div id='inputBoxSubTextView'>{inputBoxSubTextComponent}</div> : ''}
            </div>
        );
    }
}

export default InputBox;
